document.addEventListener("click", function (e) {
  const link = e.target.closest("a[href^='#'], a[href^='/#']");
  if (!link) return;

  const href = link.getAttribute("href");

  // 1. Procurar o botão real de fechar
  const closeBtn = document.querySelector("header-menu[variant='mobile']")?.shadowRoot?.querySelector("button") 
                || document.querySelector("button.menu-drawer__close-button")
                || document.querySelector("[aria-label='Close']");

  // 2. Se existir, clicar nele
  if (closeBtn) {
    closeBtn.click();
  }

  // 3. Se estiver noutra página → redirecionar
  const isOnHome =
    window.location.pathname === "/" ||
    window.location.pathname === "/index";

  if (!isOnHome) {
    e.preventDefault();
    window.location.href = `/${href.replace("/", "")}`;
  }
});
